import React from 'react';
import { Autocomplete, TextField, createFilterOptions } from '@mui/material';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';

import type { LineMaster } from '../../types/station/station';
import type { SelectLineStationType } from '../pages/Home';

type SelectLineProps = {
  index: number;
  lines?: LineMaster[];
  selectedList: SelectLineStationType[];
  setSelectedLine: (line: LineMaster) => void;
  readOnly?: boolean;
};

export const SelectLine = ({
  index,
  lines = [],
  selectedList,
  setSelectedLine,
  readOnly = false,
}: SelectLineProps) => {
  const isDispTarget = (line: LineMaster, i: number) => {
    if (selectedList[i - 1]?.line?.lineCode === line?.lineCode) {
      return false;
    }
    return true;
  };

  return (
    <div className="flex items-center">
      <ArrowForwardIosRoundedIcon sx={{ width: '50px' }} />
      <Autocomplete
        options={lines}
        getOptionLabel={(line) => line.lineName}
        sx={{ width: '300px' }}
        filterOptions={
          index
            ? (options) => options.filter((item) => isDispTarget(item, index))
            : createFilterOptions()
        }
        onChange={(_, value) => setSelectedLine(value!)}
        renderInput={(params) => (
          <TextField {...params} label="路線" placeholder="東海道本線" />
        )}
        readOnly={readOnly}
      />
    </div>
  );
};
